export default __webpack_public_path__ + "static/media/NoteImageDesktop.85539945.png";